import React, { Fragment, useState, useEffect } from "react";
import API from "@unisearch/helpers/api";
import { Grid, Skeleton } from "@mui/material";
import styles from "./study_admission_requirement.module.scss";
import { countryNameHelper } from "@unisearch/helpers";

export const StudyAdmissionRequirement = ({ countryInfo }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(
          `/public/country/admission-requirements/${countryInfo?.countryId}`
        );
        setLoading(false);
        setData(res.data);
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, [countryInfo?.countryId]);

  const LoadingComponent = () => (
    <>
      <Skeleton
        variant="rectangular"
        width="30%"
        height={30}
        sx={{ margin: "10px auto" }}
      />
      <Skeleton
        variant="rectangular"
        width="50%"
        height={50}
        sx={{ margin: "20px auto" }}
      />
      <Grid container spacing={3} alignItems={"center"}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((_, i) => {
          return (
            <Grid item xs={12} sm={12} md={4} lg={3} key={i}>
              <Skeleton variant="rectangular" width="100%" height={200} />
            </Grid>
          );
        })}
      </Grid>
    </>
  );

  return (
    <Fragment>
      {data && data?.length > 0 ? (
        <section>
          <div className="container">
            {loading ? (
              <LoadingComponent />
            ) : (
              <div className={styles.wrapper}>
                <div className={styles.heading_wrapper}>
                  <h2>
                    Admission Requirements{" "}
                    {countryInfo?.name ? (
                      <>({countryNameHelper(countryInfo)})</>
                    ) : (
                      ""
                    )}
                  </h2>
                  <p>
                    Here are the major requirements to study in{" "}
                    {countryInfo?.name} which you need to ensure while applying
                    to a {countryInfo?.name} university:
                  </p>
                </div>

                <ul className={styles.requirement_lists}>
                  {data?.map((item, i) => (
                    <li key={i}>
                      {item?.icon !== null && (
                        <div className={styles.icon_wrapper}>
                          <img src={item?.icon?.src} alt={item?.icon?.alt} />
                        </div>
                      )}
                      <div className={styles.desc}>
                        {item?.specializationName}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </section>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default StudyAdmissionRequirement;
